import {
  format,
  formatDistanceToNowStrict,
  isToday,
  isYesterday,
} from "date-fns";
import type { ClaimTranslator, LastUpdatedDisplay } from "./types";

export const formatMoney = (
  amount: number | null | undefined,
  currency = "USD",
): string | null => {
  if (amount == null) {
    return null;
  }
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  }).format(amount);
};

export const formatLastUpdated = (
  value: Date | string | null | undefined,
  t: ClaimTranslator,
): LastUpdatedDisplay | null => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const relative = getRelativeLabel(date);
  const timezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "local time";
  const exact = format(date, "MMM d, yyyy · h:mm a");

  return {
    primary: t("status.lastUpdated", { relative }),
    secondary: t("status.lastUpdatedExact", { date: exact, timezone }),
  };
};

const getRelativeLabel = (date: Date): string => {
  const distance = formatDistanceToNowStrict(date, { addSuffix: true });

  if (isToday(date)) {
    const minutes = Math.floor((Date.now() - date.getTime()) / 60000);
    if (minutes < 1) {
      return "just now";
    }
    if (minutes < 60) {
      return minutes === 1 ? "a minute ago" : `${minutes} minutes ago`;
    }
  }

  if (isYesterday(date)) {
    return "yesterday";
  }

  return distance;
};
